module.exports = __webpack_public_path__ + "static/video-placeholder-86c68b281ae02da1645e798cea6dbaf5.jpg";